import { useEffect, useMemo } from 'react';
// Components
import { DropdownMenuCard } from 'components/Card';
import { parsedCustomerSignatureSelector } from 'slices/auth.slice';
/// Slices
import {
  fetchReservationTemplatesForOtherPages,
  reservationTemplatesForOtherPagesSelector,
} from 'slices/reservationTemplate.slice';
import { useAppDispatch, useAppSelector } from 'slices/store';
import { TEDrawerSection } from '@timeedit/ui-components';

interface AttributesProps {
  value: any;
  onChangeValue: (key: string, value: any) => void;
}

const ReservationTemplate = ({ value, onChangeValue }: AttributesProps) => {
  const allReservationTemplate = useAppSelector(
    reservationTemplatesForOtherPagesSelector
  );
  const customerSignature = useAppSelector(parsedCustomerSignatureSelector);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!allReservationTemplate || allReservationTemplate.length === 0) {
      dispatch(fetchReservationTemplatesForOtherPages());
    }
  }, [allReservationTemplate, dispatch]);

  const reservationTemplatesOptions = useMemo(() => {
    if (allReservationTemplate && allReservationTemplate.length > 0) {
      return allReservationTemplate
        ?.map((field: any) => ({
          key: field.id,
          label: '' + field.name,
          url: `/${customerSignature}/configuration/reservation-templates?item1=${field.id}`,
          disable: true,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
    }
    return [];
  }, [allReservationTemplate, customerSignature]);

  return (
    <TEDrawerSection label="Connected reservation templates">
      <div className="wrapper-section">
        <div className="section-item">
          <div className="te-drawer-input">
            <DropdownMenuCard
              title="Reservation Templates"
              selectedKeys={value.reservationTemplates || []}
              options={reservationTemplatesOptions as any}
              onChange={(values) =>
                onChangeValue('reservationTemplates', values.map(Number))
              }
              readonly
            />
          </div>
        </div>
      </div>
    </TEDrawerSection>
  );
};

export default ReservationTemplate;
